export default "__VITE_ASSET__BcteWwwy__"